<template>
  <v-container fluid class="test_green">
    <v-col cols="12" class="test_blue">
      <v-row justify="center" class="test_green">
        <v-col cols="12" class="d-flex justify-center list-empty">
          <v-list-item key="empty" class="my-2 px-1">
            <v-list-item-content>
              <v-container fluid fill-height class="test_red">
                <v-row justify="center" class="test_yellow">
                  <v-col cols="12" class="text-center">
                    <v-icon disabled large v-text="'mdi-file-move-outline'" />
                    <span class="pl-3" v-text="$t(title)" />
                  </v-col>
                </v-row>
              </v-container>
            </v-list-item-content>
          </v-list-item>
        </v-col>
      </v-row>
    </v-col>
  </v-container>
</template>

<script>
export default {
  name: "CardEmptyList",
  props: {
    title: {
      type: String,
      required: true,
    },
  },
};
</script>
<style lang="scss">
.list-empty {
  height: 100px;
  border-color: var(--v-primary-base) !important;
  border: dashed;
  border-width: 1.5px;
  background-color: rgba($color: #aaa, $alpha: 0.2);
  height: 100px;
  border-radius: 5px;
}
</style>
